import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3001_2223)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.9375 8.28516L10.3125 3.91016C10.5586 3.66406 10.9688 3.66406 11.2148 3.91016C11.4883 4.15625 11.4883 4.59375 11.2148 4.83984L7.30469 8.75L11.2148 12.6602C11.4883 12.9062 11.4883 13.3438 11.2148 13.5898C10.9688 13.8359 10.5586 13.8359 10.3125 13.5898L5.9375 9.21484C5.66406 8.96875 5.66406 8.53125 5.9375 8.28516Z",
			fill: "#868686"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3001_2223",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgIconArrowLeft;
